import { observer } from 'mobx-react';
import { Component, createRef } from 'react';

export interface LogEntry {
    timestamp: string;
    level: 'SUCCESS' | 'WARNING' | 'INFO' | 'ERROR';
    message: string;
}

export interface TaskLogsProps {
    logs: LogEntry[];
    autoScroll?: boolean;
}

const LevelColor = {
    SUCCESS: 'text-success',
    WARNING: 'text-warning',
    ERROR: 'text-danger',
    INFO: 'text-info'
};

@observer
export class TaskLogs extends Component<TaskLogsProps> {
    private logsEndRef = createRef<HTMLElement>();

    componentDidUpdate() {
        if (this.props.autoScroll)
            this.logsEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }

    render() {
        const { logs } = this.props;

        return (
            <div
                className="task-logs bg-dark text-light p-3 rounded"
                style={{
                    fontFamily: 'monospace',
                    fontSize: '0.875rem',
                    maxHeight: '500px',
                    overflowY: 'auto'
                }}
            >
                {logs.map(({ timestamp, level, message }, index) => (
                    <div key={index} className="mb-1">
                        <span className="text-muted">{timestamp}</span>
                        <span className={`ms-2 fw-bold ${LevelColor[level]}`}>
                            {level}
                        </span>
                        <span className="ms-2">{message}</span>
                    </div>
                ))}
                <footer ref={this.logsEndRef} />
            </div>
        );
    }
}
